import React, { useState, useEffect } from 'react'
import { Layout, Menu, ConfigProvider, Popover } from 'antd'
import { DatabaseOutlined, PayCircleOutlined, TrophyOutlined, UsergroupAddOutlined, FundProjectionScreenOutlined, ContactsOutlined, AppstoreAddOutlined, RightOutlined, LogoutOutlined, UserOutlined, RobotOutlined } from '@ant-design/icons'
import { Outlet, useLocation, useNavigate, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { fetchMenuList } from '@/store/modules/permission'
import styles from './index.module.scss'
import './index.scss'
import { getUserInfo, removeToken, removeUserInfo } from '@/utils/token'
import { getMenuList, removeMenuList, removePathList, removeMenuPathList, removeButtonList } from '@/utils/menu'
//  引入antd汉化包
import zhCN from 'antd/locale/zh_CN'
const { Sider, Content } = Layout
const iconList = {
  DatabaseOutlined: <DatabaseOutlined className="font-size18" />,
  PayCircleOutlined: <PayCircleOutlined className="font-size18" />,
  TrophyOutlined: <TrophyOutlined className="font-size18" />,
  UsergroupAddOutlined: <UsergroupAddOutlined className="font-size18" />,
  FundProjectionScreenOutlined: <FundProjectionScreenOutlined className="font-size18" />,
  ContactsOutlined: <ContactsOutlined className="font-size18" />,
  AppstoreAddOutlined: <AppstoreAddOutlined className="font-size18" />,
  RobotOutlined: <RobotOutlined className="font-size18" />,
}

const ManageCenter = () => {
  //  标签
  const [menuList, setMenuList] = useState([]) //  菜单列表
  const [allKeys, setAllKeys] = useState([]) //  菜单列表
  const userinfo = getUserInfo()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  //  菜单高亮
  const location = useLocation()
  const selectedKey = location.pathname
  
  const onMenuClick = ({ key }) => {
    navigate(key)
  }
  const changeMenuOpen = key => {
    setAllKeys(key)
  }
  const loginOut = () => {
    removeToken()
    removeUserInfo()
    removeMenuList()
    removePathList()
    removeMenuPathList()
    removeButtonList()
    navigate('/')
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(fetchMenuList())
      let menulist = getMenuList() || []
      if(menulist.length > 0) {
        let allKeys = []
        menulist.forEach(item => {
          item.icon = iconList[item.icon]
          allKeys.push(item.key)
        })
        setMenuList(menulist)
        setAllKeys(allKeys)
      }
    }
    fetchData();
  }, [])
  return (
    <ConfigProvider locale={zhCN}>
      <Layout className="page flex" hasSider={true}>
        <Sider className="left height-100" trigger={null} collapsible>
          <img src="/images/logo.png" className="logo" />
          <div className={styles['left-menu']}>
            <Menu openKeys={allKeys} mode="inline" selectedKeys={selectedKey} items={menuList} onClick={onMenuClick} style={{ background: '#EEF0F4' }} onOpenChange={changeMenuOpen} />
          </div>
          <Popover placement="right" content={
            <div>
              <Link target="_blank" to="/managecenter/account" className='black'>
                <div className={['flex', 'align-items',  'margin-right-16', 'margin-left-16', 'cursor-pointer'].join(' ')}>
                  <UserOutlined />
                  <div className='margin-left-10'>账户详情</div>
                </div>
              </Link>
              <div className={['flex', 'align-items',  'margin-right-16', 'margin-left-16', 'cursor-pointer', 'margin-top-16'].join(' ')} onClick={loginOut}>
                <LogoutOutlined />
                <div className='margin-left-10'>退出登录</div>
              </div>
            </div>
          }>
            <div className={['flex-between', 'margin-top-24', 'margin-bottom-24', 'margin-right-16', 'margin-left-16'].join(' ')}>
              <div className={['flex', 'align-items'].join(' ')}>
                <img src={userinfo.avatar} className="avatar-24" />
                <div className={['margin-left-10', 'font-size16'].join(' ')}>{decodeURIComponent(userinfo.userName)}</div>
              </div>
              <RightOutlined />
            </div>
          </Popover>
        </Sider>
        <div className="right-main flex-1">
          <Layout className="right height-100">
            {/* <Header className="userinfo">
              <Button
                  type="text"
                  icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: '16px',
                    width: 48,
                    height: 48
                  }}
                />
              <div className="userinfo-right">
                <div className="iconfont icon-bell" />
                <img src={userinfo.avatar} className="logo" />
                <div className="username">{decodeURIComponent(userinfo.userName)}</div>
              </div>
            </Header> */}
            <div className="flex-1">
              <div className="height-100 main-box">
                <Content className="height-100">
                  <Outlet />
                </Content>
              </div>
            </div>
          </Layout>
        </div>
      </Layout>
    </ConfigProvider>
  )
}

export default ManageCenter